module.exports = __webpack_public_path__ + "static/media/AH.1bca0ac6.svg";